import { touch } from "redux-form";
import { formName } from "Constants/constants";
import { touchRegistered } from "./actions";

export const confirmInsuredAndPaymentForm = () => (dispatch) => {
  dispatch(
    touch(
      formName,
      "insuredFirstName",
      "insuredLastName",
      "insuredAddress",
      "insuredCity",
      "insuredState",
      "insuredZip",
      "contactPhone",
      "contactEmail",
      "consentConfirmed",
    ),
  );
  dispatch(
    touchRegistered(
      formName,
      "contactFirstName",
      "contactLastName",
      "insuredCompany",
      "northDakotaDisclosure",
    ),
  );
};
